const validateIdNumber = (value: string) => {
  if (value.trim().length > 0) {
    return true;
  }

  return 'Please enter valid number';
};

export default validateIdNumber;
